import {
   VideoConsultationNotificationConfiguration,
   VideoConsultationNotificationConfigurationQuery,
} from '@dreryk/egabinet-phone-notification-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

type PatientPhoneNotificationVideoConsultationReminderConfigurationModalLoaderRenderProps = {
   videoConsultationNotificationConfiguration: VideoConsultationNotificationConfiguration;
};

type PatientPhoneNotificationVideoConsultationReminderConfigurationModalLoaderProps = {
   children: (
      renderProps: PatientPhoneNotificationVideoConsultationReminderConfigurationModalLoaderRenderProps
   ) => JSX.Element;
};

export const PatientPhoneNotificationVideoConsultationReminderConfigurationModalLoader = (
   props: PatientPhoneNotificationVideoConsultationReminderConfigurationModalLoaderProps
): JSX.Element => {
   const {
      data: videoConsultationNotificationConfiguration,
      loading: videoConsultationNotificationConfigurationLoading,
      error: videoConsultationNotificationConfigurationError,
   } = useCqrsGet<VideoConsultationNotificationConfiguration>(
      () => new VideoConsultationNotificationConfigurationQuery()
   );

   if (videoConsultationNotificationConfigurationLoading) {
      return <LoaderSpinner />;
   }

   if (videoConsultationNotificationConfigurationError) {
      return (
         <Message
            testId={'videoConsultationNotificationConfigurationFetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      videoConsultationNotificationConfiguration: videoConsultationNotificationConfiguration,
   });
};
